/* eslint-disable no-unused-vars */
import Headers from "../components/Headers/Headers"
import Layout from "../components/Layout/Layout"
import ReservationComp from "../components/ReservationComp/ReservationComp"
import { AccessTime, AttachMoney, Build, Business, BusinessCenter, CalendarToday, Celebration, Coffee, Cottage, DirectionsCar, Elderly, Engineering, EventAvailable, FlightTakeoff, HomeMax, Inventory, LocalShipping, Lock, Map, People, Person, Phone, PriceCheck, School, Security, Warehouse } from "@mui/icons-material"
import { Box, Grid, List, ListItem, ListItemText, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, Button, Card, CardContent, ListItemIcon } from "@mui/material"
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import BusinessIcon from "@mui/icons-material/Business";

import { styled } from '@mui/material/styles';
import { Helmet } from "react-helmet-async"
import TableServices from "../components/TableServices/TableServices"
import Home from "./Home"

const MainGrid = styled(Grid)(({ theme }) => ({
    marginBottom: "6rem"
}));


const TitleText = styled(Typography)(({ theme }) => ({
    textTransform: "uppercase",
    color: theme.palette.secondary.main,
    fontWeight: 500
}));

const TitleTextOther = styled(Typography)(({ theme }) => ({
    textTransform: "uppercase",
    fontWeight: 700,
}));

const BoxGrid = styled(Grid)(({ theme }) => ({
    backgroundColor: "rgb(245,245,245)",
    width: "100%",
    textAlign: "left",
    padding: theme.spacing(3)
}));
const iconStyle = { color: 'primary.main' };


function Sluzby() {
    return (
        <>
            <Helmet>
                <title>RS Rent Služby | Stěhovací služby a půjčovna vozů</title>
                <meta name="description" content="Nabízíme profesionální stěhovací služby a půjčovnu vozů. Přestěhujeme vás rychle a bezpečně za skvělé ceny. RSrent.cz - váš partner pro stěhování." />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="canonical" href="https://rsrent.cz/sluzby" />
            </Helmet>
            <Layout>
                <Headers>Služby</Headers>
                <Container maxWidth="lg" sx={{
                    p: 2,
                    mt: 12
                }}>
                    <MainGrid container gap={1}>
                        <BoxGrid item md={12}>
                            <Typography variant="h4" color="secondary">
                                Zapůjčení dodávky
                            </Typography>
                            <Typography variant="body1" sx={{ color: "text.secondary" }}>
                                Potřebujete přepravit větší náklad, ale nechcete si kupovat vlastní dodávku? Půjčení dodávky je praktickým a ekonomickým řešením.
                            </Typography>

                            <Grid container sx={{ mt: 4 }}>
                                <Grid item xs={12} md={6}>
                                    <Typography
                                        variant="h5"
                                        component="h3"
                                        gutterBottom
                                        sx={{
                                            backgroundColor: "secondary.main",
                                            color: "white",
                                            p: 1,
                                            mb: 1,
                                            textTransform: "uppercase",
                                            mr: 1
                                        }}
                                    >
                                        Proč si půjčit dodávku?
                                    </Typography>
                                    <List>
                                        <ListItem>
                                            <ListItemIcon>
                                                <LocalShipping sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Stěhování"
                                                secondary="Ať už se stěhujete do nového bytu nebo potřebujete převézt nábytek pro rekonstrukci, dodávka vám usnadní práci."
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <ShoppingCartIcon sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Přeprava nákupu"
                                                secondary="Větší nákupy nábytku, stavebního materiálu nebo jiných objemných věcí už nebudou problém."
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <Cottage sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Doprava na chalupu"
                                                secondary="Snadno převezete zahradní nábytek, sekačku nebo jiné vybavení na chalupu."
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <BusinessCenter sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Podnikání"
                                                secondary="Pro firmy je půjčení dodávky ideální pro rozvoz zboží nebo přepravu materiálu na stavbu."
                                            />
                                        </ListItem>
                                    </List>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Typography
                                        variant="h5"
                                        component="h3"
                                        gutterBottom
                                        sx={{
                                            backgroundColor: "secondary.main",
                                            color: "white",
                                            p: 1,
                                            mb: 1,
                                            textTransform: "uppercase",
                                        }}
                                    >
                                        Co nabízíme?
                                    </Typography>
                                    <List>
                                        <ListItem>
                                            <ListItemIcon>
                                                <Inventory sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Široký výběr dodávek"
                                                secondary="Od malých dodávek pro menší náklady až po velké dodávky s vysokou nosností."
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <CalendarToday sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Flexibilní pronájem"
                                                secondary="Vyberte si délku pronájmu podle svých potřeb, od několika hodin až po několik dní."
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <Build sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Dodávky v perfektním stavu"
                                                secondary="Naše dodávky jsou pravidelně servisovány a vždy připraveny k použití."
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <AttachMoney sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Výhodné ceny"
                                                secondary="Nabízíme konkurenceschopné ceny a možnost pronájmu na víkend nebo dlouhodobě."
                                            />
                                        </ListItem>
                                    </List>
                                </Grid>
                            </Grid>
                        </BoxGrid>

                        <BoxGrid item md={12}>
                            <TableServices></TableServices>
                        </BoxGrid>
                        <Grid container gap={1}>
                            <Grid item sx={{
                                textAlign: "center",
                                boxShadow: "0px 3px 26px 5px #f2f2f2",
                                p: 2
                            }} xs={12} md={6}><Typography variant="body1">Dotankování do plna - nafta.</Typography></Grid>
                            <Grid item sx={{
                                textAlign: "center",
                                boxShadow: "0px 3px 26px 5px #f2f2f2",
                                p: 2
                            }} xs={12} md={true}><Typography variant="body1">Každý další km nad rámec nájezdu +12 Kč.</Typography></Grid>
                            <Grid item sx={{
                                textAlign: "center",
                                boxShadow: "0px 3px 26px 5px #f2f2f2",
                                p: 2
                            }} xs={12} md={6}><Typography variant="body1">Vratná kauce 2000 Kč.</Typography></Grid>
                            <Grid item sx={{
                                textAlign: "center",
                                boxShadow: "0px 3px 26px 5px #f2f2f2",
                                p: 2
                            }} xs={12} md={true}><Typography variant="body1">Spoluúčast 5000 Kč.</Typography></Grid>
                            <Grid item sx={{
                                textAlign: "center",
                                boxShadow: "0px 3px 26px 5px #f2f2f2",
                                p: 2
                            }} xs={12}><Typography variant="body1">Delší trasy po domluvě.</Typography></Grid>
                        </Grid>

                        <Grid item xs={12} sx={{
                            textAlign: "center",
                            boxShadow: "0px 3px 26px 5px #f2f2f2",
                            p: 2,
                            backgroundColor: "secondary.main",
                            color: "white"
                        }}>
                            <TitleTextOther variant="h5">Podmínky zapůjčení</TitleTextOther>
                        </Grid>
                        <Grid item sx={{
                            boxShadow: "0px 3px 26px 5px #f2f2f2",
                            p: 2
                        }} xs={12}>
                            <List>
                                <ListItem divider>
                                    <ListItemText primaryTypographyProps={{
                                        fontWeight: 500
                                    }} primary="Občanský průkaz" />
                                </ListItem>
                                <ListItem divider>
                                    <ListItemText primaryTypographyProps={{
                                        fontWeight: 500
                                    }} primary="Řidičský průkaz skupiny B" />
                                </ListItem>
                                <ListItem divider>
                                    <ListItemText primaryTypographyProps={{
                                        fontWeight: 500
                                    }} primary="Vratná kauce 2000 Kč. Bude vrácena zpět po předání dodávky." />
                                </ListItem>
                                <ListItem divider>
                                    <ListItemText primaryTypographyProps={{
                                        fontWeight: 500
                                    }} primary="Při podpisu smlouvy se skládá vratná kauce a cena za pronájem v hotovosti." />
                                </ListItem>
                                <ListItem divider>
                                    <ListItemText primaryTypographyProps={{
                                        fontWeight: 500
                                    }} primary="Při vrácení dodávky požadujeme doklad o dotankování " />
                                </ListItem>
                            </List>
                        </Grid>
                        <ReservationComp></ReservationComp>
                    </MainGrid>
                    <MainGrid container gap={1}>
                        <BoxGrid item md={12}>
                            <Typography variant="h4" color={"secondary"}>
                                Půjčení vozu s řidičem
                            </Typography>
                            <Typography variant="body1" sx={{ color: "text.secondary" }}>
                                Potřebujete se dostat z místa na místo bez stresu z řízení? Služba půjčení vozu s řidičem je ideálním řešením pro vás.
                            </Typography>
                            <Grid container sx={{ mt: 4 }}>
                                <Grid item xs={12} md={6}>
                                    <List>
                                        <ListItem>
                                            <ListItemText primary="Vy si určíte cíl, my se postaráme o zbytek." />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemText primary="Zkušený řidič vás pohodlně a bezpečně doveze kamkoliv si budete přát." />
                                        </ListItem>
                                    </List>
                                    <Typography variant="h5" component="h3" gutterBottom sx={{ backgroundColor: "secondary.main", color: "white", p: 1, mb: 0, textTransform: "uppercase", mr: 1 }}>
                                        Co získáte?
                                    </Typography>
                                    <List>
                                        <ListItem>
                                            <ListItemIcon>
                                                <Coffee sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Více času pro sebe"
                                                secondary="Využijte cestu k odpočinku, práci nebo konverzaci."
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <Security sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Bezpečí"
                                                secondary="Soustřeďte se na své cíle, o řízení se postaráme my."
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <DirectionsCar sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Pohodlí"
                                                secondary="Cestujte stylově a pohodlně."
                                            />
                                        </ListItem>
                                    </List>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Typography variant="h5" component="h3" gutterBottom sx={{ backgroundColor: "secondary.main", color: "white", p: 1, mb: 0, textTransform: "uppercase", mr: 1 }}>
                                        Proč si vybrat právě nás?
                                    </Typography>
                                    <List>
                                        <ListItem>
                                            <ListItemIcon>
                                                <AccessTime sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Flexibilita"
                                                secondary="Přizpůsobíme se vašim časovým požadavkům a itineráři."
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <DirectionsCar sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Komfort"
                                                secondary="Naše vozy jsou vybaveny vším potřebným pro příjemnou jízdu."
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <Security sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Bezpečnost"
                                                secondary="Naši řidiči jsou profesionálové s dlouholetými zkušenostmi."
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <Lock sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Diskrétnost"
                                                secondary="Zaručujeme maximální soukromí během vaší cesty."
                                            />
                                        </ListItem>
                                    </List>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="h5" component="h3" mb={1} gutterBottom sx={{ backgroundColor: "secondary.main", color: "white", p: 1, mb: 0, textTransform: "uppercase", mr: 1 }}>
                                        Kdy využít službu půjčení vozu s řidičem?
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <List>
                                                <ListItem>
                                                    <ListItemIcon>
                                                        <FlightTakeoff sx={iconStyle} />
                                                    </ListItemIcon>
                                                    <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                        primary="Letištní transfery"
                                                        secondary="Pohodlný a spolehlivý transport na letiště a zpět."
                                                    />
                                                </ListItem>
                                                <ListItem>
                                                    <ListItemIcon>
                                                        <BusinessCenter sx={iconStyle} />
                                                    </ListItemIcon>
                                                    <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                        primary="Obchodní jednání"
                                                        secondary="Udělejte profesionální dojem na své obchodní partnery."
                                                    />
                                                </ListItem>
                                            </List>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <List>
                                                <ListItem>
                                                    <ListItemIcon>
                                                        <Celebration sx={iconStyle} />
                                                    </ListItemIcon>
                                                    <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                        primary="Společenské akce"
                                                        secondary="Dorazte stylově na svatby, večírky nebo jiné události."
                                                    />
                                                </ListItem>
                                                <ListItem>
                                                    <ListItemIcon>
                                                        <Map sx={iconStyle} />
                                                    </ListItemIcon>
                                                    <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                        primary="Výlety"
                                                        secondary="Objevujte nové destinace bez starostí o řízení."
                                                    />
                                                </ListItem>
                                            </List>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </BoxGrid>
                        <BoxGrid item md={12} >
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >Vozidlo</TitleText>
                                        <Typography variant="body1" fontWeight={600}>600 Kč/h</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} md={4} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >Řidič</TitleText>
                                        <Typography variant="body1" fontWeight={600}>300 Kč/h</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} md={4} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" color="initial">Příklad</TitleText>
                                        <Typography variant="body1" fontWeight={600}>Dodávka s řidičem 900 Kč za každou započatou hodinu</Typography>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </BoxGrid>
                        <Grid container gap={1}>
                            <Grid item sx={{
                                textAlign: "center",
                                boxShadow: "0px 3px 26px 5px #f2f2f2",
                                p: 2
                            }} xs={12} md={6}><Typography variant="body1">Po Mladé Boleslavi doprava zdarma.</Typography></Grid>
                            <Grid item sx={{
                                textAlign: "center",
                                boxShadow: "0px 3px 26px 5px #f2f2f2",
                                p: 2
                            }} xs={12} md={true}><Typography variant="body1">Každý další ujetý km mimo MB + 12 Kč.</Typography></Grid>
                            <Grid item sx={{
                                textAlign: "center",
                                boxShadow: "0px 3px 26px 5px #f2f2f2",
                                p: 2
                            }} xs={12}><Typography variant="body1">Delší trasy po domluvě.</Typography></Grid>
                        </Grid>
                        <ReservationComp></ReservationComp>
                    </MainGrid>
                    <MainGrid container gap={1}>
                        <BoxGrid item md={12}>
                            <Typography variant="h4" color="secondary">
                                Stěhování
                            </Typography>
                            <Typography variant="body1" color={"text.secondary"} >
                                Potřebujete přestěhovat nábytek, osobní věci nebo jiné předměty, ale nemáte vlastní dopravu? Služba stěhování s řidičem je pro vás ideálním řešením.

                            </Typography>


                            <Grid container sx={{ mt: 4 }}>
                                <Grid item xs={12} md={6}>
                                <List>
                                <ListItem>
                                    <ListItemText primary="Vy si zabalíte své věci do krabic a připravíte je k odvozu." />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="My zajistíme vozidlo vhodné pro přepravu vašeho nákladu a zkušeného řidiče." />
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary="Řidič vám pomůže s nakládkou a vykládkou, zajistí bezpečné uložení věcí v autě a dopraví je na požadované místo." />
                                </ListItem>
                            </List>
                                    <Typography
                                        variant="h5"
                                        component="h3"
                                        gutterBottom
                                        sx={{
                                            backgroundColor: "secondary.main",
                                            color: "white",
                                            p: 1,
                                            mb: 1,
                                            textTransform: "uppercase",
                                            mr: 1
                                        }}
                                    >
                                        Výhody stěhování s řidičem:
                                    </Typography>
                                    <List>
                                        <ListItem>
                                            <ListItemIcon>
                                                <EventAvailable sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Flexibilita"
                                                secondary="Můžete si vybrat termín stěhování, který vám vyhovuje."
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <AccessTime sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Úspora času a námahy"
                                                secondary="Nemusíte se starat o hledání vhodného vozidla nebo organizaci stěhování."
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <Security sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Bezpečnost"
                                                secondary="Zkušený řidič zajistí bezpečnou přepravu vašich věcí."
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <AttachMoney sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Cenově dostupné"
                                                secondary="Cena je obvykle nižší než u klasických stěhovacích firem."
                                            />
                                        </ListItem>
                                    </List>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Typography
                                        variant="h5"
                                        component="h3"
                                        gutterBottom
                                        sx={{
                                            backgroundColor: "secondary.main",
                                            color: "white",
                                            p: 1,
                                            mb: 1,
                                            textTransform: "uppercase",
                                        }}
                                    >
                                        Pro koho je tato služba vhodná?
                                    </Typography>
                                    <List>
                                        <ListItem>
                                            <ListItemIcon>
                                                <Person sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Pro jednotlivce"
                                                secondary="Pokud se stěhujete do menšího bytu nebo potřebujete přepravit pouze několik kusů nábytku."
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <Business sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Pro malé firmy"
                                                secondary="Pro přepravu kancelářského vybavení nebo zboží."
                                            />
                                        </ListItem>
                                        <ListItem>
                                            <ListItemIcon>
                                                <Elderly sx={iconStyle} />
                                            </ListItemIcon>
                                            <ListItemText secondaryTypographyProps={{ fontSize: 15 }}
                                                primary="Pro seniory"
                                                secondary="Pokud potřebujete pomoc s přestěhováním a nemáte sílu nebo možnost zajistit si vlastní dopravu."
                                            />
                                        </ListItem>
                                    </List>
                                </Grid>
                            </Grid>
                        </BoxGrid>


                        <BoxGrid item md={12}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >Vozidlo s řidičem</TitleText>
                                        <Typography variant="body1" fontWeight={600}>1000 Kč/h</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} md={4} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >+1. stěhovák</TitleText>
                                        <Typography variant="body1" fontWeight={600}>250 Kč/h</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} md={4} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >+2. stěhovák</TitleText>
                                        <Typography variant="body1" fontWeight={600}>500 Kč/h</Typography>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </BoxGrid>
                        <Grid container gap={1}>
                            <Grid item sx={{
                                textAlign: "center",
                                boxShadow: "0px 3px 26px 5px #f2f2f2",
                                p: 2
                            }} xs={12} md={6}><Typography variant="body1">Maximální obsazení vozu jsou 3 os. 1500 Kč./hod.</Typography></Grid>
                            <Grid item sx={{
                                textAlign: "center",
                                boxShadow: "0px 3px 26px 5px #f2f2f2",
                                p: 2
                            }} xs={12} md={true}><Typography variant="body1">Každý další ujetý km mimo MB + 12 Kč.</Typography></Grid>
                            <Grid item sx={{
                                textAlign: "center",
                                boxShadow: "0px 3px 26px 5px #f2f2f2",
                                p: 2
                            }} xs={12}><Typography variant="body1">Delší trasy po domluvě.</Typography></Grid>
                        </Grid>
                        <ReservationComp></ReservationComp>
                    </MainGrid>
                    <MainGrid container gap={1}>
                        <BoxGrid item md={12}>
                            <Typography variant="h4" color={"secondary"}>
                                Ostatní služby
                            </Typography>
                        </BoxGrid>
                        <BoxGrid item md={12} mt={2} sx={{
                            backgroundColor: "rgba(243,66,19,1)"
                        }}>
                            <TitleTextOther variant="h5" color={"white"} textAlign={"center"}>
                                Montáž a demontáž nábytku
                            </TitleTextOther>
                        </BoxGrid>
                        <BoxGrid item md={12}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >1 osoba</TitleText>
                                        <Typography variant="body1" fontWeight={600}>250 Kč/h</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} md={6} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >2 osoba</TitleText>
                                        <Typography variant="body1" fontWeight={600}>500 Kč/h</Typography>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </BoxGrid>
                        <BoxGrid item md={12} mt={2} sx={{
                            backgroundColor: "rgba(243,66,19,1)"
                        }}>
                            <TitleTextOther variant="h5" textAlign={"center"} color={"white"}>
                                Stěhování těžkých břemen
                            </TitleTextOther>
                        </BoxGrid>
                        <BoxGrid item md={12}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >2 pracovníci</TitleText>
                                        <Typography variant="body1" fontWeight={600}>600 Kč/h</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} md={4} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >3 pracovníci</TitleText>
                                        <Typography variant="body1" fontWeight={600}>900 Kč/h</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} md={4} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >4 pracovníci</TitleText>
                                        <Typography variant="body1" fontWeight={600}>1200 Kč/h</Typography>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </BoxGrid>
                        <BoxGrid item md={12} mt={2} sx={{
                            backgroundColor: "rgba(243,66,19,1)"
                        }}>
                            <TitleTextOther variant="h5" textAlign={"center"} color={"white"}>
                                Příplatek za těžké břemeno
                            </TitleTextOther>
                        </BoxGrid>
                        <BoxGrid item md={12}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >100 - 199 kg</TitleText>
                                        <Typography variant="body1" fontWeight={600}>300 Kč/h</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} md={4} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >Každých dalších + 100kg</TitleText>
                                        <Typography variant="body1" fontWeight={600}>50 Kč/h</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} md={4} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >4 pracovníci</TitleText>
                                        <Typography variant="body1" fontWeight={600}>1200 Kč/h</Typography>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </BoxGrid>
                        <BoxGrid item md={12} mt={2} sx={{
                            backgroundColor: "rgba(243,66,19,1)"
                        }}>
                            <TitleTextOther variant="h5" textAlign={"center"} color={"white"}>
                                Obalový materiál
                            </TitleTextOther>
                        </BoxGrid>
                        <BoxGrid item md={12}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={3} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >Folie</TitleText>
                                        <Typography variant="body1" fontWeight={600}>180 Kč/role</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} md={3} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >Krabice 60x60x40cm Max. 15kg</TitleText>
                                        <Typography variant="body1" fontWeight={600}>40 Kč/h</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} md={3} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >Bublinková folie</TitleText>
                                        <Typography variant="body1" fontWeight={600}>10 Kč/m</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={12} md={3} sx={{
                                    textAlign: "center"
                                }}>
                                    <Stack>
                                        <TitleText variant="body1" >Lepící papírová páska</TitleText>
                                        <Typography variant="body1" fontWeight={600}>50 Kč</Typography>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </BoxGrid>
                    </MainGrid>
                </Container>
            </Layout>
        </>
    )
}

export default Sluzby